// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__d5FhT","avatar":"styles_avatar__yTjdu","userLocationIndicatorInCenter":"styles_userLocationIndicatorInCenter__lro4d"};